import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class Home extends Component {
  render() {
    return (
      <div className="m-5">
        <h1>Woolly Buggers</h1>
        <br />
        <div>
          <Link to="/admin/map_data" className="bg-transparent text-secondary">
            River & Lake Info
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/upload_pdf" className="bg-transparent text-secondary">
            Fishing Regulations - PDF upload
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/water_regulations" className="bg-transparent text-secondary">
            Fishing Regulations - Water Regulations
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/cpw_properties" className="bg-transparent text-secondary">
            Fishing Regulations - CPW Property Access
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/state_trust_lands" className="bg-transparent text-secondary">
            Fishing Regulations - State Trust Lands
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/state_parks" className="bg-transparent text-secondary">
            Fishing Regulations - State Parks
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/accept_shops" className="bg-transparent text-secondary">
            Approve Shops
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/road_status" className="bg-transparent text-secondary">
            Road Status
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/fishing_forecast" className="bg-transparent text-secondary">
            Fishing Weather
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/fishing_rules" className="bg-transparent text-secondary">
            Fishing Rules
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/hatch_tracker" className="bg-transparent text-secondary">
            Hatch Tracker
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/fish_stocking" className="bg-transparent text-secondary">
            Fish Stocking
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/hiking_trails" className="bg-transparent text-secondary">
            Hiking Trails
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/stream_gauges" className="bg-transparent text-secondary">
            Stream Gauges
          </Link>
        </div>
        <br />
        <div>
          <Link to="/admin/password" className="bg-transparent text-secondary">
            Change password
          </Link>
        </div>
        <br />
        {/* <div>
          <Link to="/admin/onboarding_shops" className="bg-transparent text-secondary">Onboarding Shops</Link>
        </div>
        <br/> */}
        <div>
          <a href="/admin/logout" className="bg-transparent text-secondary">
            Logout
          </a>
        </div>
      </div>
    );
  }
}
